const prefix = '/materiality-assessment/{maId}';

export const SPECIFIC_CUSTOM_LIST_TAG = `${prefix}/risk-sectors`;
export const SPECIFIC_CUSTOM_DETAILS_TAG = `${prefix}/risk-sectors/id`;
